export function createBaseEndpoints(base) {
  return {
    list: `${base}`,
    add: `${base}/Add`,
    update: `${base}/Update`,
    details: `${base}/GetDetails`,
    delete: `${base}/Delete`,
  }
}
